import { render, staticRenderFns } from "./TurnPart.vue?vue&type=template&id=b08f9a8a&scoped=true&"
import script from "./TurnPart.vue?vue&type=script&lang=js&"
export * from "./TurnPart.vue?vue&type=script&lang=js&"
import style0 from "./TurnPart.vue?vue&type=style&index=0&id=b08f9a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08f9a8a",
  null
  
)

export default component.exports